<template>
  <div
    v-if="hasAjaxErrorMessages"
    class="alert-error sticky island"
    tabindex="-1"
  >
    <div class="icon">
      <div class="af-icons-md af-icons-md-alert-error"></div>
    </div>
    <div class="message">
      <p
        v-if="validatorMessage"
        v-html="lang.get('miscellaneous.alerts.validator.message')"
      ></p>
      <p
        v-if="hasMultipleTabs && validatorMessage"
        v-html="lang.get('miscellaneous.alerts.validator.tabs')"
      ></p>
      <ul class="errors">
        <li
          v-for="(error, i) in ajaxErrorMessages"
          :key="'error-message-' + i"
          v-html="error"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

const toastr = require('toastr');

export default {
  inject: ['lang'],
  props: {
    validatorMessage: {
      type: Boolean,
      value: true
    }
  },
  data() {
    return {
      ajaxErrorMessages: []
    };
  },
  computed: {
    ...mapState('entryFormApi', { ajaxErrors: 'errorBag' }),
    ...mapState('entryForm', ['tabsLoaded']),
    ...mapGetters('entryForm', ['visibleTabs']),
    hasAjaxErrorMessages() {
      return this.ajaxErrorMessages.length > 0;
    },
    hasMultipleTabs() {
      return this.tabsLoaded && this.visibleTabs && this.visibleTabs.length > 1;
    }
  },
  watch: {
    ajaxErrors(errors) {
      this.ajaxErrorMessages = [];

      if (errors && typeof errors === 'object') {
        if (errors.type && errors.message) {
          switch (errors.type) {
            case 'info':
              toastr.info(errors.message);
              break;
            case 'warning':
              toastr.warning(errors.message);
              break;
            case 'success':
              toastr.success(errors.message);
              break;
            default:
              this.ajaxErrorMessages = [errors.message];
              break;
          }
          return;
        }

        for (let i in errors) {
          if (Array.isArray(errors[i].message)) {
            this.validatorMessage = true;
            if (errors[i].message[1] === 'error' && i === '1') {
              this.validatorMessage = false;
              errors[i].message.splice(1, 1);
            }
            // Flatten array
            errors[i].message
              .reduce((acc, val) => acc.concat(val), [])
              .forEach(e => {
                this.ajaxErrorMessages.push(e);
              });
          }
        }
      }
    }
  }
};
</script>
